module.exports = __webpack_public_path__ + "static/media/10.2d72a94d.jpg";